
        var result = require("!!../../../../node_modules/css-loader/index.js!./ticket-log.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/ticket-log/ticket-log.component.css
// module id = 732
// module chunks = 0